module.exports = __webpack_public_path__ + "static/media/USGoldLogoUse.728b98ca.pdf";